import { useEffect } from 'react';

import { OrderType, TrackingApi } from 'api/TrackingApi';

interface Props {
  orderType: OrderType;
}

export const useOneClickPayAnalytics = ({ orderType }: Props) => {
  const trackResignShow = (orderId: string | null) => {
    TrackingApi.trackResignShow({
      orderId: orderId ?? '',
      orderType,
    });
  };

  useEffect(() => {
    TrackingApi.trackRecurringShow({
      orderType,
    }).catch((err) => err);

    return () => {
      TrackingApi.trackRecurringClose({
        orderType,
      }).catch((err) => err);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    trackResignShow,
  };
};
